import {
  useGetMyRequestsQuery,
  useGetRequestsQuery,
} from '@/redux/slices/requestApiSlice';
import { ListRequestsArgs } from '@/types/requests';
import { useGetLoggedUser } from './useGetLoggedUser';
import { OrganizationUserRoleSlugs } from '@/types/users';
import { skipToken } from '@reduxjs/toolkit/query/react';

type UseGetRequestsDataProps = {
  queryAll: boolean;
  params: typeof skipToken | ListRequestsArgs;
};

export const useGetMyRequestsOrGetAllRequests = ({
  queryAll,
  params,
}: UseGetRequestsDataProps) => {
  const loggedUser = useGetLoggedUser();
  const isAdminOrProductSupport = !!loggedUser.organizationUserRoles?.some(
    role =>
      role.slug === OrganizationUserRoleSlugs.SUPER_ADMIN ||
      role.slug === OrganizationUserRoleSlugs.PRODUCT_SUPPORT
  );

  const paramsForMyQuery = !queryAll ? params : skipToken;
  const {
    data: myTasks,
    isLoading: myTasksLoading,
    error: myTasksError,
    isFetching: myTasksFetching,
  } = useGetMyRequestsQuery(paramsForMyQuery);

  const paramsForAllQuery =
    queryAll && isAdminOrProductSupport ? params : skipToken;
  const {
    data: allTasks,
    isLoading: allTasksLoading,
    error: allTasksError,
    isFetching: allTasksFetching,
  } = useGetRequestsQuery(paramsForAllQuery);

  return {
    data: queryAll ? allTasks : myTasks,
    isLoading: queryAll ? allTasksLoading : myTasksLoading,
    error: queryAll ? allTasksError : myTasksError,
    isFetching: queryAll ? allTasksFetching : myTasksFetching,
  };
};
